/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function AIAgentSidesheet({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g clipPath="url(#AIAgentSidesheet_svg__a)"><path fill="currentColor" d="M13.443.9c1.148 0 2.157.875 2.157 2.045v10.11c0 1.17-1.009 2.045-2.157 2.045H2.556c-.558 0-1.101-.207-1.508-.584A2 2 0 0 1 .4 13.055V2.945C.4 1.775 1.408.901 2.556.9zM2.556 2.1c-.578 0-.955.427-.955.845v10.11c0 .209.088.42.263.582.176.163.424.262.692.262h10.887c.578 0 .956-.426.956-.844V2.945c0-.418-.378-.844-.956-.844zM11.8 3.3A1.2 1.2 0 0 1 13 4.5v7l-.006.122a1.2 1.2 0 0 1-1.071 1.071l-.123.007H9.2l-.123-.007a1.2 1.2 0 0 1-1.071-1.07L8 11.5v-7a1.2 1.2 0 0 1 1.077-1.194L9.2 3.3zm-2.6 8.2h2.6v-7H9.2z" /></g><defs><clipPath id="AIAgentSidesheet_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;